import React from 'react';
export const TestimonialsSection: React.FC = () => {
  const testimonials = [{
    name: 'Martín R.',
    location: 'Buenos Aires',
    desc: 'Empezó desde cero',
    quote: 'Hice mi primera operación a los 5 días. Compré una cadena 18k a una vecina y la vendí en Once. Gané USD 120 limpio.',
    initial: 'M'
  }, {
    name: 'Laura P.',
    location: 'Morón',
    desc: 'Revendedora en ferias',
    quote: 'Lo que más me sirvió fue la parte de las pruebas. Ahora identifico enchapado en 10 segundos y no me la ponen.',
    initial: 'L'
  }, {
    name: 'Diego S.',
    location: 'Lomas de Zamora',
    desc: '3 meses operando',
    quote: 'La calculadora es genial. No tengo que hacer cuentas a mano. Pongo gramos y quilates y ya sé cuánto ofrecer.',
    initial: 'D'
  }, {
    name: 'Camila G.',
    location: 'San Martín',
    desc: 'Ingreso extra',
    quote: 'Empecé vendiendo las joyas viejas de mi mamá y me di cuenta del margen que había. Ahora compro todas las semanas.',
    initial: 'C'
  }];
  return <section className="py-20" style={{
    background: 'var(--bg-card)'
  }} data-id="element-184">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-185">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-186">
          Personas que ya empezaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-187">
          {testimonials.map((test, idx) => <div key={idx} className="rounded-xl p-7 border" style={{
          background: 'var(--bg-dark)',
          borderColor: 'var(--border-subtle)'
        }} data-id="element-188">
              <p className="text-sm italic mb-4 leading-relaxed" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-189">
                "{test.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-190">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-extrabold flex-shrink-0" style={{
              background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
              color: 'var(--bg-dark)'
            }} data-id="element-191">
                  {test.initial}
                </div>
                <div data-id="element-192">
                  <p className="font-semibold text-sm" data-id="element-193">{test.name}</p>
                  <p className="text-xs" style={{
                color: 'var(--text-muted)'
              }} data-id="element-194">
                    {test.location} · {test.desc}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};